export default __webpack_public_path__ + "static/media/favicon-x.163d4107.ico";